module.exports = __webpack_public_path__ + "assets/media/lunch.67c032e7.mp3";